class BankAccountStageController {}

export default BankAccountStageController;
